<app-shared-drawer [title]="drawerTitle" className="wck-occurrence-manage-drawer"
  contentClassName="wck-occurrence-manage-drawer" [isOpen]="true" (onClose)="onClose()">
  <section *ngIf="!loadingStates.actions" id="actions">
    <div class="action-list">
      <ngb-accordion #acc="ngbAccordion" *ngIf="actionsList?.length" [activeIds]="activeIds">
        <ng-container *ngFor="let action of actionsList; let i = index; trackBy: trackByActionId">
          <ngb-panel id="panel-{{ i }}" [cardClass]="'card-fit mb-1'">
            <ng-template ngbPanelTitle let-opened="opened">
              <div class="flex justify-content-between align-items-center">
                <!-- Ícone + Label -->
                <span class="flex align-items-center">
                  <span class="mr-1" [ngClass]="{
                      'text-primary': isCompleted(i),
                      'text-warning': !isCompleted(i) }">
                    <i [data-feather]="isCompleted(i) ? 'check-circle' : 'alert-circle'"></i>
                  </span>
                  <span *ngIf="actionsList.length > 1">
                    Ação {{ i + 1 }} - {{ action.typeTitle }}
                  </span>
                  <span *ngIf="actionsList.length === 1"> Ação - {{ action.typeTitle }} </span>
                </span>

                <!-- Ícone Arrow -->
                <span class="arrow-icon-wrapper">
                  <i [class]="
                      acc.isExpanded('panel-' + i) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
                    "></i>
                </span>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row">
                <div class="col-md">
                  <div class="form-group">
                    <label class="form-control-label form-label" for="what-{{ i }}">O que</label>
                    <input [disabled]="true" [(ngModel)]="action.what" id="what-{{ i }}" type="text"
                      class="form-control" placeholder="O que" />
                  </div>
                </div>

                <div class="col-md">
                  <div class="form-group">
                    <label class="form-control-label form-label" for="forecastDate-{{ i }}">Previsão</label>
                    <input [disabled]="true" [(ngModel)]="action.forecastDate" id="forecastDate-{{ i }}" type="date"
                      class="form-control" placeholder="Previsão" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="form-control-label form-label" for="responsible-{{ i }}">Responsável</label>
                <input id="responsible-{{ i }}" type="text" class="form-control" [disabled]="true"
                  [value]="action.responsible?.name || action.responsibleName" placeholder="Responsável" />
              </div>
              <div class="form-group">
                <label class="form-control-label form-label" for="description-{{ i }}">Descrição</label>
                <textarea [disabled]="true" [(ngModel)]="action.description" id="description-{{ i }}"
                  class="form-control" placeholder="Descrição" rows="3"></textarea>
              </div>
              <!-- <div class="form-group mb-0">
                <label class="form-control-label"class="form-label" for="status-{{ i }}">Status</label>
                <ng-select [disabled]="true" [(ngModel)]="action.status" class="ng-select-custom auto-grow-options"
                  [items]="actionStatusOptions" appendTo="body" bindLabel="label" bindValue="value"
                  placeholder="Status"></ng-select>
              </div> -->
              <div class="col-md-12 col-12">
                <div class="divider divider-primary">
                  <div class="divider-text">Resolução</div>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="formContent; context: { index: i }"></ng-container>
            </ng-template>
          </ngb-panel>
        </ng-container>
      </ngb-accordion>
    </div>
  </section>

  <section *ngIf="loadingStates.actions" id="loading">
    <div class="card-body pb-1">
      <div class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center">
        <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
        <span>Carregando</span>
      </div>
    </div>
  </section>
</app-shared-drawer>

<ng-template #formContent let-index="index">
  <form class="form-horizontal" [formGroup]="getActionForm(index)" (ngSubmit)="handleSubmit(index)">
    <div class="form-group">
      <label class="form-control-label form-label" for="treat-resolutionDescription-{{ index }}">
        Descrição da resolução <span class="text-danger">*</span>
      </label>
      <textarea formControlName="resolutionDescription" id="treat-resolutionDescription-{{ index }}"
        class="form-control" placeholder="Descrição da resolução" rows="3"></textarea>
      <div class="invalid-feedback d-block" *ngIf="getActionForm(index).get('resolutionDescription')?.invalid && getActionForm(index).get('resolutionDescription')?.touched">
        Descrição da resolução é obrigatória.
      </div>
    </div>

    <div class="form-group mb-1">
      <label class="form-control-label form-label" for="status-{{ index }}">
        Status <span class="text-danger">*</span>
      </label>
      <ng-select class="ng-select-custom auto-grow-options" [items]="actionStatusOptions" appendTo="body"
        bindLabel="label" bindValue="value" placeholder="Selecione o status" formControlName="status"></ng-select>
      <div class="invalid-feedback d-block" *ngIf="getActionForm(index).get('status')?.invalid && getActionForm(index).get('status')?.touched">
        Status é obrigatório.
      </div>
    </div>

    <div class="form-group">
      <app-dropzone-files #dropzone [readonly]="isCompleted(index)" [fileContent]="fileContent(index)" [multiple]="false"
        [allowedFileTypes]="['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']"
        (onChangeFiles)="onFileSelectionChanged($event, index)" (onGetFile)="onGetFile(index)">
      </app-dropzone-files>
    </div>
    <div *ngIf="!isCompleted(index)" class="row">
      <div class="col-12 mt-2 d-flex justify-content-end">
        <button [disabled]="!getActionForm(index).valid" type="submit" rippleEffect class="btn btn-gradient-primary">
          Salvar
        </button>
      </div>
    </div>
  </form>
</ng-template>